// extracted by mini-css-extract-plugin
export default {"tncContainer":"TNC_tncContainer__wF-nU","ft_44_900":"TNC_ft_44_900__QoAum","ft_24_700":"TNC_ft_24_700__P+fHO","ft_18":"TNC_ft_18__0U40V","textBtn":"TNC_textBtn__uHCRj"};